<template>
    <div class="Assistance">
        <div class="pageContent">
            <TopLogoBar logoColor="black" textColor="#000" title="TELEASSISTENZA" />
            <div class="container infoContainer">
                <div class="columns">
                    <div class="column is-4 downloadPanel">
                        <div class="downloadTitle">Ammyy</div>
                        <a class="downloadButton" href="http://www.ammyy.com/it/index.html" target="_blank">
                            <svg class="svg-icon" viewBox="0 0 20 20">
                                <path fill="none"
                                    d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z">
                                </path>
                            </svg>
                        </a>
                    </div>
                    <div class="column is-4 downloadPanel">
                        <div class="downloadTitle">TeamViewer</div>
                        <a class="downloadButton" href="https://www.page93.it/download/TeamViewerQS.exe">
                            <svg class="svg-icon" viewBox="0 0 20 20">
                                <path fill="none"
                                    d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z">
                                </path>
                            </svg>
                        </a>
                    </div>
                    <div class="column is-4 downloadPanel">
                        <div class="downloadTitle">Iperius Remote</div>
                        <a class="downloadButton" href="https://www.page93.it/download/IperiusRemote.exe">
                            <svg class="svg-icon" viewBox="0 0 20 20">
                                <path fill="none"
                                    d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z">
                                </path>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
    import Footer from '@/components/Footer'
    import TopLogoBar from '@/components/TopLogoBar'
    export default {
        name: 'Assistance',
        props: [],
        components: {
            TopLogoBar,
            Footer
        },
    }
</script>

<style scoped lang="scss">
    .Assistance {
        width: 100%;

        .pageContent {
            width: 100%;
            position: relative;
            color: #000;

            .infoContainer {
                // display: flex;
                // height: 100%;
                padding: 20px;
                padding-top: 150px;

                @media only screen and (max-width: 768px) {
                    padding-top: 50px;
                }

                .downloadPanel {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 900;
                    font-size: 22px;
                    flex-direction: column;
                    //height: 300px;

                    .downloadTitle {
                        display: block;
                    }

                    .downloadButton {
                        margin-top: 50px;
                        background-color: #000;
                        color: #fff;
                        padding: 10px;
                        height: 80px;
                        width: 80px;
                        display: block;
                        line-height: 60px;
                        text-align: center;
                        border-radius: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        transition: all .5s ease-in-out;

                        @media only screen and (max-width: 768px) {
                            margin-top: 10px;
                        }

                        .svg-icon {
                            width: 1.5em;
                            height: 1.5em;
                            transition: all .1s ease-in-out;
                        }

                        .svg-icon path,
                        .svg-icon polygon,
                        .svg-icon rect {
                            fill: #fff;
                        }

                        .svg-icon circle {
                            stroke: #fff;
                            stroke-width: 1;
                        }

                        &:hover {
                            .svg-icon {
                                width: 1em;
                                height: 1em;
                            }
                        }
                    }
                }
            }
        }
    }
</style>